import { ChartTypeRegistry, TooltipItem } from "chart.js";
import { formatCurrencyToAda } from "../../../utils/number-format";
import { TTasteTestTargetPriceChartConfig } from "./TasteTestTargetPriceChart";

export const getTasteTestTargetPriceChartTooltips = (config: TTasteTestTargetPriceChartConfig) => {
  const { currentLocale, t } = config;
  return {
    title: (tooltipItem: TooltipItem<keyof ChartTypeRegistry>[]) => {
      return `${new Intl.DateTimeFormat(currentLocale, {
        dateStyle: "long",
        timeStyle: "short",
      }).format(new Date(tooltipItem[0].parsed.x))}`;
    },
    label: (tooltipItem: TooltipItem<keyof ChartTypeRegistry>) => {
      return `${t?.("detail.priceChart.title")}: ${formatCurrencyToAda(
        tooltipItem.parsed.y,
        currentLocale
      )}`;
    },
  };
};
